import { RDEqipFieldsSelection } from '@cibo/core'
import { ResourceDetailFeature } from '@cibo/ui'
import { FieldsSelectionFeatureTaskEditor } from './FieldsSelectionFeatureTaskEditor'

export const RDEqipFieldsSelectionFeature: ResourceDetailFeature<RDEqipFieldsSelection> = {
  traitId: 'eqipSelectedPractices',
  TaskEditor: FieldsSelectionFeatureTaskEditor,
  selfIsland: true,
}
